import type { TagColor, TagOption } from '@/shared/data/tags';

export const resolveEntityTags = (row: object): string[] => {
  const value = (row as { tags?: unknown }).tags;
  if (!Array.isArray(value)) return [];
  return value.filter((tag): tag is string => typeof tag === 'string' && tag.length > 0);
};

export const formatEntityTagsLabel = (tags: string[] | undefined): string => {
  if (!tags || tags.length === 0) return '-';
  return tags.join(', ');
};

export type TagColorByName = Partial<Record<string, TagColor>>;

export const buildTagColorByName = (tagOptions: TagOption[]): Record<string, TagColor> =>
  tagOptions.reduce<Record<string, TagColor>>((acc, option) => {
    acc[option.value] = option.color;
    acc[option.value.trim().toLowerCase()] = option.color;
    return acc;
  }, {});

export const mergeTagColorByName = (
  ...sources: Array<TagColorByName | null | undefined>
): Record<string, TagColor> =>
  sources.reduce<Record<string, TagColor>>((acc, source) => {
    if (!source) return acc;
    Object.entries(source).forEach(([key, value]) => {
      if (value !== undefined) {
        acc[key] = value;
      }
    });
    return acc;
  }, {});

export const resolveTagColor = (tag: string, tagColorByName: TagColorByName): TagColor => {
  const trimmed = tag.trim();
  return tagColorByName[trimmed] ?? tagColorByName[trimmed.toLowerCase()] ?? 'neutral';
};
